// This const is used for nothing except to make this file identifiable via its content.
// We search for "_sentry_release_injection_file" in the plugin to determine for sure that the file we look at is the release injection file.

// _sentry_release_injection_file

    var _global =
      typeof window !== 'undefined' ?
        window :
        typeof global !== 'undefined' ?
          global :
          typeof self !== 'undefined' ?
            self :
            {};

    _global.SENTRY_RELEASE={id:"732152be5f9e98a6918ef591cb5012abbc9e5e67"};